const { Sortable } = require('sortablejs')

function initSortable() {
  const sortableContainer = document.querySelector('.js-sortable')
  const sortableInstance = Sortable.create(sortableContainer, {
    sort: true,
    handle: '.js-sortable-handle',
    onUpdate: function() {
      $.ajax({
        url: sortableContainer.dataset.url,
        type: 'PUT',
        data: {
          [sortableContainer.dataset.modelName]: this.toArray()
        }
      })
    }
  })
}

module.exports = initSortable
$(document).ready(initSortable)
$(document).on('page:load turbolinks:load', initSortable)
